import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { GanttReponse } from "../models/GanttReponse";
import { ShiftInfo } from "../models/ShiftInfo";

const moment = getMomentTz();

export const getGanttData = async (
	params: {
		start: Date | undefined;
		end: Date | undefined;
		assetId: number | undefined;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Start", value: params.start?.toISOString() ?? null },
		{ name: "End", value: params.end?.toISOString() ?? null },
		{ name: "AssetId", value: params.assetId ?? null },
	];

	const resp = await apiService.callV2(
		"[M1].[GetGanttData]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const data = resp.data as GanttReponse;

		// RS1: production groups
		data.tables[0].rows = data.tables[0].rows.map((row) => {
			row.Start = moment.utc(row["Start"]).toDate();
			row.End = moment.utc(row["End"]).toDate();
			return row;
		});
		// RS2: delays
		data.tables[1].rows = data.tables[1].rows.map((row) => {
			row.Start = moment.utc(row["Start"]).toDate();
			row.End = row["End"] ? moment.utc(row["End"]).toDate() : null;
			return row;
		});
		// RS4: section production event stats
		data.tables[3].rows = data.tables[3].rows.map((row) => {
			row.RollingStart = row["RollingStart"]
				? moment.utc(row["RollingStart"]).toDate()
				: null;
			row.SectionSpansMultipleShifts =
				(row["SectionSpansMultipleShifts"] as unknown as number) === 1;
			return row;
		});
		// RS5: roll changes
		data.tables[4].rows = data.tables[4].rows.map((row) => {
			row.Start = row["Start"] ? moment.utc(row["Start"]).toDate() : null;
			row.End = row["End"] ? moment.utc(row["End"]).toDate() : null;
			return row;
		});
		// RS6: D/M/H events
		data.tables[5].rows = data.tables[5].rows.map((row) => {
			row.Start = row["Start"] ? moment.utc(row["Start"]).toDate() : null;
			row.End = row["End"] ? moment.utc(row["End"]).toDate() : null;
			row.CreatedAt = row["CreatedAt"]
				? moment.utc(row["CreatedAt"]).toDate()
				: null;
			return row;
		});
		// RS7: gap time intervals
		data.tables[6].rows = data.tables[6].rows.map((row) => {
			row.Start = row["Start"] ? moment.utc(row["Start"]).toDate() : null;
			row.End = row["End"] ? moment.utc(row["End"]).toDate() : null;
			return row;
		});
		// RS8: stacker bundles
		data.tables[7].rows = data.tables[7].rows.map((row) => {
			row.Timestamp = row["Timestamp"]
				? moment.utc(row["Timestamp"]).toDate()
				: null;
			return row;
		});

		return {
			errorMessage: null,
			tables: data.tables,
		} as GanttReponse;
	} else {
		throw new Error(resp.message || "Error fetching gantt data");
	}
};

export const getTrendingData = async (
	params: {
		start: Date | undefined;
		end: Date | undefined;
		assetId: number | undefined;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Start", value: params.start?.toISOString() ?? null },
		{ name: "End", value: params.end?.toISOString() ?? null },
		{ name: "AssetId", value: params.assetId ?? null },
	];

	const resp = await apiService.callV2(
		"[M1].[GetTrendingData]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", null) as ShiftInfo[];
	} else {
		throw new Error(resp.message || "Error fetching gantt data");
	}
};
